// Persistenz der Plan-Zimmerkontingente einer Reise-Metadaten-Saison

// Bündelt Endpunkte und Payload-Aufbau, damit die Karte rein präsentationsnah bleibt
import apiService from '@/core/common/services/api.service';

// Baut den Request-Body eines Plan-Zimmerkontingents
// die geteilte Anzahl wird nur gesetzt, wenn tatsächlich ein Kontingent geteilt wird
function buildBody(zimmerkontingent) {
  return {
    zimmertyp: zimmerkontingent.zimmertyp,
    anzahlEinheiten: zimmerkontingent.anzahlEinheiten,
    anzahlGeteiltesKontingent: zimmerkontingent.teiltkontingentMit
      ? zimmerkontingent.anzahlGeteiltesKontingent
      : null,
    teiltkontingentMit: zimmerkontingent.teiltkontingentMit ?? null,
  };
}

// Legt ein neues Plan-Zimmerkontingent an
export function create(reisekuerzel, gueltigAb, zimmerkontingent) {
  return apiService.post(
    `Reise/${reisekuerzel}/metadata/${gueltigAb}/planzimmerkontingent`,
    buildBody(zimmerkontingent)
  );
}

// Aktualisiert ein bestehendes Plan-Zimmerkontingent
export function update(reisekuerzel, gueltigAb, zimmerkontingent) {
  return apiService.put(
    `Reise/${reisekuerzel}/metadata/${gueltigAb}/planzimmerkontingent?planZimmerkontingentId=${zimmerkontingent.id}`,
    buildBody(zimmerkontingent)
  );
}

// Löscht ein Plan-Zimmerkontingent
export function remove(reisekuerzel, gueltigAb, planZimmerkontingentId) {
  return apiService.delete(
    `Reise/${reisekuerzel}/metadata/${gueltigAb}/planzimmerkontingent?planZimmerkontingentId=${planZimmerkontingentId}`
  );
}
